import React from 'react';
import {  Icon, notification, Modal } from 'antd';
import jwt_decode from "jwt-decode";

// Create a component for the content
const ErrorMessageContent = ({ message }) => (
  <div dangerouslySetInnerHTML={{ __html: message }} />
);

export function displayError(errorMessage) {
  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    let decoded = jwt_decode(localStorage.getItem("ACCESS_TOKEN"));
    let current_time = new Date().getTime() / 1000;
    if (current_time > decoded.exp) {
      return;
    }
  }
  Modal.error({
    // title: 'Verification not complete',
    content: <ErrorMessageContent message={errorMessage} />,
    //  icon: <warning style={{ color: 'red' }} />
     icon: <Icon type="warning" style={{ color: '#0A9EB2' }} />
  });

  /*
  notification.error({
    message: 'Brdgx',
    description: errorMessage + "222"
  });
  */
}

export function displayGenericError(error) {
  console.log(new Error().stack);
  if (localStorage.getItem("ACCESS_TOKEN") != null) {
    let decoded = jwt_decode(localStorage.getItem("ACCESS_TOKEN"));
    let current_time = new Date().getTime() / 1000;
    if (current_time > decoded.exp) {
      return;
    }
  }
  if (!error) {
    notification.error({
      message: 'Brdgx',
      description: 'Sorry! Something went wrong. Please try again!'
    });
  } else {
    if( error.message !== 'Session timeout' && error.status !== 401){
      Modal.error({
        title: error.message || error.result || 'Sorry! Something went wrong. Please try again!',
        content: ''
      });
    }

    /*
    notification.error({
      message: 'Error',
      description: error.message || error.result || 'Sorry! Something went wrong. Please try again!'
    });
    */
  }
}

export function displaySuccessMessage(message) {
  notification.success({
    message: 'Brdgx',
    description: message
  })
}
export function displayWarningMessage(message) {
  notification.warning({
    message: 'Brdgx',
    description: message
  })
}
export function displayWarningMessageWithSeconds(message, seconds) {
  notification.warning({
    message: 'Brdgx',
    duration: seconds,
    description: message
  })
}
export function displaySuccessMessageWithSeconds(message, seconds) {
  notification.success({
    message: 'Brdgx',
    duration: seconds,
    description: message
  })
}